import { graphql } from '@teachino/shared-infrastructure';
import { folderFragment } from './folder.fragment';
import { topicListItemFragment } from './topic-list-item';
import { materialListItemFragment } from '../materials/material-list-item.fragment';

export const libraryFoldersQuery = graphql(
  `
    query LibraryFolders($selectedFolderId: String, $search: String) {
      libraryFolders {
        ...Folder
      }
      libraryMeta {
        totalTopicsCount
        unsortedTopicsCount
      }
      searchContent(
        contentSearchInput: {
          search: $search
          libraryFolderId: $selectedFolderId
          searchType: TOPIC
        }
      ) {
        ... on BaseModel {
          id
          __typename
        }
        ... on TopicInstance {
          position
        }
        ... on Folder {
          id
          ...TopicListItem
        }
      }
      libraryNewestContent(libraryNewestContentInput: { limit: 6 }) {
        materials {
          ...MaterialListItem
        }
      }
    }
  `,
  [folderFragment, topicListItemFragment, materialListItemFragment],
);
